import styled from "styled-components";
import { mediaMaxWidth } from "../../../theme/mediaQueriesTemplates";

interface IWrapperProps {
  pdfExport?: boolean;
}

export const Wrapper = styled.div`
  height: 200px;
  width: ${(props: IWrapperProps) => props.pdfExport && "850px"};
  display: flex;
  flex-direction: column;
  background-color: #fff;
  padding: ${(props: IWrapperProps) => !props.pdfExport && "10px"};
  border-radius: 8px;
  position: relative;
  box-shadow: ${(props: IWrapperProps) =>
    !props.pdfExport && "rgb(220, 220, 220) 0px 0px 15px"};
  transform: ${(props: IWrapperProps) =>
    props.pdfExport && "scale(0.75) translateX(-86px) translateY(-11px)"};
  margin: ${(props: IWrapperProps) => !props.pdfExport && "0 10px 20px 10px"};
  overflow: hidden;
  animation-delay: 0.15s;

  ${mediaMaxWidth.mediumDesktop} {
    height: ${(props: IWrapperProps) => !props.pdfExport && "unset"};
    width: ${(props: IWrapperProps) => !props.pdfExport && "850px"};
    margin: ${(props: IWrapperProps) => !props.pdfExport && "0 auto 20px auto"};
  }

  ${mediaMaxWidth.smallDesktop} {
    width: ${(props: IWrapperProps) =>
      !props.pdfExport && "calc(100vw - 100px)"};
  }

  ${mediaMaxWidth.tablet} {
    width: ${(props: IWrapperProps) =>
      !props.pdfExport && "calc(100vw - 40px)"};
  }

  ${mediaMaxWidth.phone} {
    width: ${(props: IWrapperProps) =>
      !props.pdfExport && "calc(100vw - 20px)"};
    margin: ${(props: IWrapperProps) => !props.pdfExport && "0 auto 10px auto"};
  }
`;

interface IChartsProps {
  pdfExport?: boolean;
}

export const Charts = styled.div`
  display: flex;
  flex: 1;

  ${mediaMaxWidth.phone} {
    flex-direction: ${(props: IChartsProps) => !props.pdfExport && "column"};
  }
`;

export const Chart = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;

  &.animated.delay-3 {
    animation-delay: 0.45s;
  }

  ${mediaMaxWidth.phone} {
    margin: 20px 0;
  }
`;

export const ChartName = styled.div`
  z-index: 1;
  font-size: 0.9em;
  position: absolute;
  bottom: 10px;

  ${mediaMaxWidth.phone} {
    bottom: 5px;
  }
`;
